import {overEvery, includes, createSelector} from 'helpers';
import {flatten, module, today, filter} from 'store/common';
import {isRestricted} from './restricted';
import {byType} from './activities';
import {sort} from './sort';
import {preferences} from './preferences';
import {status} from './status';

const activities = createSelector(
  [ module, byType ],
  ( module, byType ) => byType[module] || [],
  { memoizeOptions: { maxSize: 10 } },
);

export const list = createSelector(
  [ activities, module, preferences, sort, today, isRestricted, filter ],
  ( activities, module, preferences, sort, today, isRestricted, filter ) => {
    let allowedStatuses = preferences.status + ', Future';
    let allowed = activities.filter(overEvery(
      activity => !isRestricted(activity),
      activity => includes(allowedStatuses, status(activity, today.unix())),
      filter,
    ));
    return flatten(sort(allowed, preferences.group))
  },
  { memoizeOptions: { maxSize: 10 } },
);
